import { ConfirmDialog } from "primereact/confirmdialog" // For <ConfirmDialog /> component
import { confirmDialog } from "primereact/confirmdialog" // For confirmDialog method

//Styles
import formStyles from "../../../styles/assessments/ManagementForm.module.css"

//Assessments components
import { Panel } from "primereact/panel"
import OutcomeEntry from "./OutcomeEntry"

export default function ManagementFormOutcomes({
  values,
  initialValues,
  disabled,
  onSetFieldValue,
  onGetFieldMeta,
}) {
  const outcomeValues =
    values?.suggestedOutcomes?.filter((x) => !x.isDeleted) || []

  //Reset changed values in an outcome entry to the initial value
  //This is to prevent validation errors on the service from invalid changes prior to deletion
  const resetOutcome = (rowData) => {
    if (!rowData.isNewOutcome && initialValues) {
      const index = values.suggestedOutcomes.indexOf(rowData)

      Object.keys(rowData).forEach((key) => {
        if (
          values.suggestedOutcomes[index][key] !==
          initialValues.suggestedOutcomes[index][key]
        ) {
          setFieldValue(index, key, initialValues.suggestedOutcomes[index][key])
        }
      })
    }
  }

  const setFieldValue = (rowData, field, value) => {
    const index = values.suggestedOutcomes.indexOf(rowData)
    onSetFieldValue(`suggestedOutcomes[${index}].${field}`, value)
  }

  const getFieldMeta = (rowData, field) => {
    const index = values.suggestedOutcomes.indexOf(rowData)
    return onGetFieldMeta(`suggestedOutcomes[${index}].${field}`)
  }

  return (
    <div className={formStyles.outcomePanel}>
      <ConfirmDialog />
      <Panel header={"Suggested Outcomes"}>
        <div className={formStyles.outcomeMainHelper}>
          <p>
            Please use Min and Max scores to set a suggested outcome that will
            be displayed to either staff, participants or both.
          </p>
          <p>
            For a single score outcome, set both the min and max values to the
            same integer.
          </p>
        </div>
        {outcomeValues
          ? outcomeValues.map((outcome) => (
              <OutcomeEntry
                profile={outcome}
                key={outcome.id}
                disabled={disabled}
                findFieldMeta={getFieldMeta}
                onChange={(profile) => {
                  const outcomeIndex = values.suggestedOutcomes.indexOf(outcome)
                  if (outcomeIndex >= 0) {
                    let outcomes = [...values.suggestedOutcomes]
                    outcomes[outcomeIndex] = profile
                    onSetFieldValue("suggestedOutcomes", outcomes)
                  } else {
                    onSetFieldValue("suggestedOutcomes", [
                      ...values.suggestedOutcomes,
                      profile,
                    ])
                  }
                }}
                onDelete={() => {
                  confirmDialog({
                    message:
                      "Are you sure you want to delete this outcome entry?",
                    header: "Confirmation",
                    icon: "pi pi-exclamation-triangle",
                    defaultFocus: "accept",
                    accept: () => {
                      resetOutcome(outcome)
                      setFieldValue(outcome, "isDeleted", true)
                    },
                    reject: () => {},
                  })
                }}
              />
            ))
          : "No suggested outcomes loaded"}
        {!disabled ? (
          <div
            className={formStyles.addOutcome}
            onClick={() => {
              const newOutcome = {
                id: undefined,
                scoreMin: 0,
                scoreMax: 0,
                text: "",
                visibleToStaff: true,
                visibleToParticipant: true,
                isDeleted: false,
                isNewOutcome: true,
              }
              onSetFieldValue("suggestedOutcomes", [
                ...values.suggestedOutcomes,
                newOutcome,
              ])
            }}
          >
            Add outcome
          </div>
        ) : null}
      </Panel>
    </div>
  )
}
